import { AvailableRate } from "@/@types/Rating/AvailableRate";
import React, { useState } from "react";
import { Card, CardBody } from "reactstrap";

interface WarningAndDisclaimerProps {
  warnings: { source: string; text: string }[];
  rates: AvailableRate[];
  disableDisclaimer?: boolean;
}
const WarningAndDisclaimer = ({
  warnings,
  rates,
  disableDisclaimer,
}: WarningAndDisclaimerProps) => {
  const [isDisclaimerOpen, setDisClaimerOpen] = useState<boolean>(false);

  const openDisclaimer = (open: boolean) => {
    setDisClaimerOpen(!open);
  };
  return (
    <>
      <div onClick={() => openDisclaimer(isDisclaimerOpen)}>
        {!isDisclaimerOpen
          ? warnings.length === 0
            ? "View Disclaimers"
            : !disableDisclaimer
            ? "View Warnings and Disclaimers"
            : "View Warnings"
          : warnings.length === 0
          ? "Hide Disclaimers"
          : !disableDisclaimer
          ? "Hide Warnings and Disclaimers"
          : "Hide Warnings"}
      </div>
      {isDisclaimerOpen && (
        <Card>
          <CardBody>
            {warnings.length > 0 && (
              <div>
                <div>Warnings:</div>
                <table>
                  {warnings?.map((warning, i) => (
                    <tr key={i}>
                      <td>• </td>
                      <td>
                        <span style={{ fontWeight: 600 }}>
                          {warning.source}
                        </span>
                        : {warning.text}
                      </td>
                    </tr>
                  ))}
                </table>
                {!disableDisclaimer && <hr />}
              </div>
            )}
            {!disableDisclaimer && (
              <div>
                <div>Disclaimers:</div>
                <table>
                  <tr>
                    <td>• </td>
                    <td>
                      Shipvista will cover your package(s) according to the
                      declared value.
                    </td>
                  </tr>
                  <tr>
                    <td>• </td>
                    <td>
                      Insurance Coverage 1% of package value (USD $1 Minimum
                      Premium)
                    </td>
                  </tr>
                  <tr>
                    <td>• </td>
                    <td>
                      These prices are estimates and subject to adjustment by
                      Shipvista.
                    </td>
                  </tr>
                  <tr>
                    <td>• </td>
                    <td>
                      Limitations to size, weight and coverage vary for
                      international destinations.
                    </td>
                  </tr>
                  {rates?.find(
                    (rate: AvailableRate) => rate.carrierName === "UPS"
                  ) ? (
                    <tr>
                      <td>• </td>
                      <td>
                        UPS, the UPS brandmark, UPS Ready®, and the color brown
                        are trademarks of United Parcel Service of America, Inc.
                        All Rights Reserved.
                      </td>
                    </tr>
                  ) : (
                    <></>
                  )}
                </table>
              </div>
            )}
          </CardBody>
        </Card>
      )}
    </>
  );
};

export default WarningAndDisclaimer;
